import { Tabs } from "antd";
import Cookies from "js-cookie";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  changingTabsWithCustomButton,
  dashboardStyleList,
} from "../../Redux/actions/Dashboard/Dashboard";
import { srfRequestData } from "../../Redux/actions/Srf/Srf";
import {
  resetMassFilter,
  resetSeasonFilter,
  selectUnselectSrtTableRows,
  srtEXportArray,
} from "../../Redux/actions/Srt/Srt";
import { resetSrMassFilter } from "../../Redux/actions/Sr/Sr"; 
import { Loader } from "../../UIComponents/Loader";
import Header from "../Header/Header";
import "./HomePage.css";
const { TabPane } = Tabs;

const HomePage = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const changeTabsToggle = useSelector((state) => state?.Dashboard?.changeTabs);
  const statusSaverloading = useSelector(
    (state) => state?.Srt?.statusSaverLoader
  );
  const loadingForLoader = useSelector(
    (state) => state?.Dashboard?.loadingForLoader
  );
  const sendSampleloading = useSelector(
    (state) => state?.Srf?.sendSampleLoader
  );
  const srfSearchLoader = useSelector((state) => state?.Srf?.searchLoader);
  const designLoaderForSrt = useSelector(
    (state) => state?.Srt?.designStatusSaverLoader
  );
  const dashboardDataLoader = useSelector(
    (state) => state?.Dashboard?.listLoader
  );

  const [tabToggle, keyFromRedux] = changeTabsToggle.split(".");

  const path = location.pathname;

  useEffect(() => {
    Cookies.set(
      "CurrentUrlPath",
      JSON.stringify({
        CurrentUrl: path,
      }),
      {
        expires: 1,
        secure: true,
        // sameSite: "Strict",
      }
    );
  }, [path]);
  const CurrentUrlPath = Cookies.get("CurrentUrlPath")
    ? JSON.parse(Cookies.get("CurrentUrlPath"))
    : null;

  const combinedPath = path || CurrentUrlPath?.CurrentUrl;

  if (combinedPath === "/dashboard") {
    localStorage.setItem("activeKey", "1");
  } else if (combinedPath === "/sample-request-form") {
    localStorage.setItem("activeKey", "2");
  } else if (combinedPath === "/sample-receipt-tracker/dickies-socks") {
    localStorage.setItem("activeKey", "3");
    localStorage.setItem("srtActiveKey", "1");
  } else if (combinedPath === "/m3-setup-sheet/dickies-socks") {
    localStorage.setItem("activeKey", "4");
    localStorage.setItem("srActiveKey", "1");
  } else if (combinedPath === "/archived-brands") {
    localStorage.setItem("activeKey", "5");
  }

  if (path === "/sample-receipt-tracker/saucony") {
    localStorage.setItem("activeKey", "3");
    localStorage.setItem("srtActiveKey", "2");
  }
  if (path == "/sample-receipt-tracker/eddie-bauer") {
    localStorage.setItem("activeKey", "3");
    localStorage.setItem("srtActiveKey", "3");
  }
  if (path == "/sample-receipt-tracker/pd") {
    localStorage.setItem("activeKey", "3");
    localStorage.setItem("srtActiveKey", "4");
  }
  if (path == "/sample-receipt-tracker/haggar") {
    localStorage.setItem("activeKey", "3");
    localStorage.setItem("srtActiveKey", "5");
  }
  if (path == "/sample-receipt-tracker/sales-samples") {
    localStorage.setItem("activeKey", "3");
    localStorage.setItem("srtActiveKey", "6");
  }
  if (path == "/sample-receipt-tracker/unsolicited-samples") {
    localStorage.setItem("activeKey", "3");
    localStorage.setItem("srtActiveKey", "7");
  }
  if (path == "/sample-receipt-tracker/dickies-underwear") {
    localStorage.setItem("activeKey", "3");
    localStorage.setItem("srtActiveKey", "8");
  }
  if (path == "/sample-receipt-tracker/my-favorite-socks") {
    localStorage.setItem("activeKey", "3");
    localStorage.setItem("srtActiveKey", "9");
  }
  if (path == "/sample-receipt-tracker/north-state") {
    localStorage.setItem("activeKey", "3");
    localStorage.setItem("srtActiveKey", "10");
  }
  if (path == "/sample-receipt-tracker/inferno") {
    localStorage.setItem("activeKey", "3");
    localStorage.setItem("srtActiveKey", "11");
  }
  if (path == "/sample-receipt-tracker/true-energy") {
    localStorage.setItem("activeKey", "3");
    localStorage.setItem("srtActiveKey", "12");
  }
  if (path == "/sample-receipt-tracker/north-state-apparel") {
    localStorage.setItem("activeKey", "3");
    localStorage.setItem("srtActiveKey", "13");
  }
  if (path == "/sample-receipt-tracker/run-dry") {
    localStorage.setItem("activeKey", "3");
    localStorage.setItem("srtActiveKey", "14");
  }
  if (path === "/m3-setup-sheet/saucony") {
    localStorage.setItem("activeKey", "4");
    localStorage.setItem("srActiveKey", "2");
  }
  if (path == "/m3-setup-sheet/eddie-bauer") {
    localStorage.setItem("activeKey", "4");
    localStorage.setItem("srActiveKey", "3");
  }
  if (path == "/m3-setup-sheet/pd") {
    localStorage.setItem("activeKey", "4");
    localStorage.setItem("srActiveKey", "4");
  }
  if (path == "/m3-setup-sheet/my-favorite-socks") {
    localStorage.setItem("activeKey", "4");
    localStorage.setItem("srActiveKey", "7");
  }
  if (path == "/m3-setup-sheet/north-state") {
    localStorage.setItem("activeKey", "4");
    localStorage.setItem("srActiveKey", "10");
  }
  if (path == "/m3-setup-sheet/inferno") {
    localStorage.setItem("activeKey", "4");
    localStorage.setItem("srActiveKey", "11");
  }
  if (path == "/m3-setup-sheet/true-energy") {
    localStorage.setItem("activeKey", "4");
    localStorage.setItem("srActiveKey", "12");
  }
  if (path == "/m3-setup-sheet/north-state-apparel") {
    localStorage.setItem("activeKey", "4");
    localStorage.setItem("srActiveKey", "13");
  }
  if (path == "/m3-setup-sheet/run-dry") {
    localStorage.setItem("activeKey", "4");
    localStorage.setItem("srActiveKey", "14");
  }
  const srtPathRedirect = localStorage.getItem("srtPath");

  const EmailUrlSrt = srtPathRedirect ? srtPathRedirect : path;

  if (
    EmailUrlSrt.includes(
      "/sample-receipt-tracker/dickies-socks/Dropped-Rejected"
    )
  ) {
    const prefix = "/sample-receipt-tracker/dickies-socks/Dropped-Rejected";
    const params = EmailUrlSrt.slice(prefix.length).split("/");
    const formattedDate = params.filter(Boolean).join("/");
    localStorage.setItem("activeKey", "3");
    localStorage.setItem("srtActiveKey", "1");
    localStorage.setItem(
      "srtData",
      JSON.stringify({
        brand: "Dickies Socks",
        style: "",
        factory: "",
        rejected_date: formattedDate,
        sale_sample: 0,
      })
    );
  }

  if (
    EmailUrlSrt.includes("/sample-receipt-tracker/saucony/Dropped-Rejected")
  ) {
    const prefix = "/sample-receipt-tracker/saucony/Dropped-Rejected";
    const params = EmailUrlSrt.slice(prefix.length).split("/");
    const formattedDate = params.filter(Boolean).join("/");

    localStorage.setItem("activeKey", "3");
    localStorage.setItem("srtActiveKey", "2");
    localStorage.setItem(
      "srtData",
      JSON.stringify({
        brand: "Saucony",
        style: "",
        factory: "",
        rejected_date: formattedDate,
        sale_sample: 0,
      })
    );
  }
  if (
    EmailUrlSrt.includes("/sample-receipt-tracker/eddie-bauer/Dropped-Rejected")
  ) {
    const prefix = "/sample-receipt-tracker/eddie-bauer/Dropped-Rejected";
    const params = EmailUrlSrt.slice(prefix.length).split("/");
    const formattedDate = params.filter(Boolean).join("/");

    localStorage.setItem("activeKey", "3");
    localStorage.setItem("srtActiveKey", "3");
    localStorage.setItem(
      "srtData",
      JSON.stringify({
        brand: "EddieBauer",
        style: "",
        factory: "",
        rejected_date: formattedDate,
        sale_sample: 0,
      })
    );
  }
  if (EmailUrlSrt.includes("/sample-receipt-tracker/pd/Dropped-Rejected")) {
    const prefix = "/sample-receipt-tracker/pd/Dropped-Rejected";
    const params = EmailUrlSrt.slice(prefix.length).split("/");
    const formattedDate = params.filter(Boolean).join("/");

    localStorage.setItem("activeKey", "3");
    localStorage.setItem("srtActiveKey", "4");
    localStorage.setItem(
      "srtData",
      JSON.stringify({
        brand: "PD",
        style: "",
        factory: "",
        rejected_date: formattedDate,
        sale_sample: 0,
      })
    );
  }
  if (EmailUrlSrt.includes("/sample-receipt-tracker/haggar/Dropped-Rejected")) {
    const prefix = "/sample-receipt-tracker/haggar/Dropped-Rejected";
    const params = EmailUrlSrt.slice(prefix.length).split("/");
    const formattedDate = params.filter(Boolean).join("/");

    localStorage.setItem("activeKey", "3");
    localStorage.setItem("srtActiveKey", "5");
    localStorage.setItem(
      "srtData",
      JSON.stringify({
        brand: "Haggar",
        style: "",
        factory: "",
        rejected_date: formattedDate,
        sale_sample: 0,
      })
    );
  }
  if (
    EmailUrlSrt.includes(
      "/sample-receipt-tracker/dickies-underwear/Dropped-Rejected"
    )
  ) {
    const prefix = "/sample-receipt-tracker/dickies-underwear/Dropped-Rejected";
    const params = EmailUrlSrt.slice(prefix.length).split("/");
    const formattedDate = params.filter(Boolean).join("/");

    localStorage.setItem("activeKey", "3");
    localStorage.setItem("srtActiveKey", "8");
    localStorage.setItem(
      "srtData",
      JSON.stringify({
        brand: "Dickies Underwear",
        style: "",
        factory: "",
        rejected_date: formattedDate,
        sale_sample: 0,
      })
    );
  }
  if (EmailUrlSrt.includes("/sample-receipt-tracker/my-favorite-socks/Dropped-Rejected")) {
    const prefix = "/sample-receipt-tracker/my-favorite-socks/Dropped-Rejected";
    const params = EmailUrlSrt.slice(prefix.length).split("/");
    const formattedDate = params.filter(Boolean).join("/");

    localStorage.setItem("activeKey", "3");
    localStorage.setItem("srtActiveKey", "9");
    localStorage.setItem(
      "srtData",
      JSON.stringify({
        brand: "My Favorite Socks",
        style: "",
        factory: "",
        rejected_date: formattedDate,
        sale_sample: 0,
      })
    );
  }
  if (EmailUrlSrt.includes("/sample-receipt-tracker/north-state/Dropped-Rejected")) {
    const prefix = "/sample-receipt-tracker/north-state/Dropped-Rejected";
    const params = EmailUrlSrt.slice(prefix.length).split("/");
    const formattedDate = params.filter(Boolean).join("/");

    localStorage.setItem("activeKey", "3");
    localStorage.setItem("srtActiveKey", "10");
    localStorage.setItem(
      "srtData",
      JSON.stringify({
        brand: "NorthState",
        style: "",
        factory: "",
        rejected_date: formattedDate,
        sale_sample: 0,
      })
    );
  }
  if (EmailUrlSrt.includes("/sample-receipt-tracker/inferno/Dropped-Rejected")) {
    const prefix = "/sample-receipt-tracker/inferno/Dropped-Rejected";
    const params = EmailUrlSrt.slice(prefix.length).split("/");
    const formattedDate = params.filter(Boolean).join("/");

    localStorage.setItem("activeKey", "3");
    localStorage.setItem("srtActiveKey", "11");
    localStorage.setItem(
      "srtData",
      JSON.stringify({
        brand: "Inferno",
        style: "",
        factory: "",
        rejected_date: formattedDate,
        sale_sample: 0,
      })
    );
  }
  if (EmailUrlSrt.includes("/sample-receipt-tracker/true-energy/Dropped-Rejected")) {
    const prefix = "/sample-receipt-tracker/true-energy/Dropped-Rejected";
    const params = EmailUrlSrt.slice(prefix.length).split("/");
    const formattedDate = params.filter(Boolean).join("/");

    localStorage.setItem("activeKey", "3");
    localStorage.setItem("srtActiveKey", "12");
    localStorage.setItem(
      "srtData",
      JSON.stringify({
        brand: "True Energy",
        style: "",
        factory: "",
        rejected_date: formattedDate,
        sale_sample: 0,
      })
    );
  }
  if (EmailUrlSrt.includes("/sample-receipt-tracker/north-state-apparel/Dropped-Rejected")) {
    const prefix = "/sample-receipt-tracker/north-state-apparel/Dropped-Rejected";
    const params = EmailUrlSrt.slice(prefix.length).split("/");
    const formattedDate = params.filter(Boolean).join("/");

    localStorage.setItem("activeKey", "3");
    localStorage.setItem("srtActiveKey", "13");
    localStorage.setItem(
      "srtData",
      JSON.stringify({
        brand: "North State Apparel",
        style: "",
        factory: "",
        rejected_date: formattedDate,
        sale_sample: 0,
      })
    );
  }
  if (EmailUrlSrt.includes("/sample-receipt-tracker/run-dry/Dropped-Rejected")) {
    const prefix = "/sample-receipt-tracker/run-dry/Dropped-Rejected";
    const params = EmailUrlSrt.slice(prefix.length).split("/");
    const formattedDate = params.filter(Boolean).join("/");

    localStorage.setItem("activeKey", "3");
    localStorage.setItem("srtActiveKey", "14");
    localStorage.setItem(
      "srtData",
      JSON.stringify({
        brand: "RunDry",
        style: "",
        factory: "",
        rejected_date: formattedDate,
        sale_sample: 0,
      })
    );
  }
  if (tabToggle == "true") {
    dispatch(changingTabsWithCustomButton(`false.3`));
  }
  const onKeyChange = (key) => {
    if (key == 1) {
      navigate("/dashboard");
      localStorage.setItem("activeKey", "1");
      localStorage.removeItem("srfPath");
      localStorage.removeItem("srtPath");
      localStorage.removeItem("currentPage");
      localStorage.removeItem("srtMassData");
      localStorage.removeItem("SrfSearchData");
      dispatch(dashboardStyleList(1, 10));
    } else if (key == 2) {
      navigate("/sample-request-form");
      localStorage.setItem("activeKey", "2");
      localStorage.removeItem("srtPath");
      localStorage.removeItem("srtMassData");
      localStorage.removeItem("currentPage");
      localStorage.removeItem("SrfSearchData");
    } else if (key == 3) {
      navigate("/sample-receipt-tracker/dickies-socks");
      localStorage.setItem("activeKey", "3");
      localStorage.setItem("srtActiveKey", "1");
      localStorage.removeItem("srfPath");
      localStorage.removeItem("currentPage");
      localStorage.removeItem("srtMassData");
      localStorage.removeItem("DashboardData");
      localStorage.removeItem("SrfSearchData");
      localStorage.setItem(
        "srtData",
        JSON.stringify({
          brand: "Dickies Socks",
          style: "",
          factory: "",
          rejected_date: "",
          sale_sample: 0,
        })
      );
      dispatch(srtEXportArray([]));
      dispatch(selectUnselectSrtTableRows([]));
      // dispatch(resetSeasonFilter([]));
      // dispatch(resetMassFilter([]));
      dispatch(srfRequestData(false));
    } else if (key == 4) {
      navigate("/m3-setup-sheet/dickies-socks");
      localStorage.setItem("activeKey", "4");
      localStorage.setItem("srActiveKey", "1");
      localStorage.removeItem("srMassData");
      localStorage.removeItem("srData");
      localStorage.setItem(
        "srData",
        JSON.stringify({
          brandFilter: "Dickies Socks",
          searchFilter: "",
          colorFilter: "",
          sizeFilter: "",
          vendorFilter: "",
          // rejected_date: "",
          sale_sample: 0,
          searchFilter: ""
        })
      );
      dispatch(resetSrMassFilter([]));
    } else if (key == 5) {
      navigate("/archived-brands");
      localStorage.setItem("activeKey", "5");
      localStorage.removeItem("srfPath");
      localStorage.removeItem("srtPath");
      localStorage.removeItem("currentPage");
      localStorage.removeItem("srtMassData");
      localStorage.removeItem("SrfSearchData");
      localStorage.setItem(
        "archivedBrandsData",
        JSON.stringify({
          searchFilter: "",
          seasonFilter: "ALL",
          openBrand: null,
          stylesPage: 1,
        })
      );
    }
  };
  const goBack = () => {
    window.history.back();
  };

  const activeKey = localStorage.getItem("activeKey");

  return (
    <div className="home-page-conatiner">
      {loadingForLoader ? <Loader /> : null}
      {srfSearchLoader ? <Loader /> : null}
      {sendSampleloading ? <Loader /> : null}
      {statusSaverloading ? <Loader /> : null}
      {designLoaderForSrt ? <Loader /> : null}
      {dashboardDataLoader ? <Loader /> : null}

      <Header />
      <div className="tabs-main">
        <div className="tabs-container">
          <Tabs
            type="card"
            disabled={true}
            activeKey={activeKey}
            onChange={onKeyChange}
          >
            <TabPane
              onClick={() => onKeyChange("1")}
              key={"1"}
              tab={<div className="tab1">Dashboard</div>}
            >
              {/* <Dashboard /> */}
            </TabPane>
            <TabPane
              onClick={() => onKeyChange("2")}
              key={"2"}
              tab={<div className="tab2">Sample Request Form</div>}
            ></TabPane>
            <TabPane
              onClick={() => onKeyChange("3")}
              key={"3"}
              tab={<div className="tab3">Sample Receipt Tracker</div>}
            ></TabPane>
            <TabPane
              onClick={() => onKeyChange("4")}
              key={"4"}
              tab={<div className="tab3">M3 Setup Sheet</div>}
            ></TabPane>
            <TabPane
              onClick={() => onKeyChange("5")}
              key={"5"}
              tab={<div className="tab3">Archived Brands</div>}
            ></TabPane>
          </Tabs>

        </div>
        <span className="back-wrapper">
          {/* <p onClick={goBack} className='tab-back'>Back</p> */}
        </span>
      </div>
    </div>
  );
};

export default HomePage;
